import React, {useCallback} from 'react';
import cx from 'classnames';
import {Link, Scrollbar, Table, Text} from '@priority-software/priority-style-react';
import {isRTL} from '../../../../Localization';
import {Value} from '../Value';
import {defaultRecordsLimit, Templates} from '../../constants';
import texts from '../../texts';
import styles from './styles.module.scss';

type Field = {
    Value: any;
    ColumnName: string;
    ColumnTitle: string;
    IsStatus?: boolean;
    Type: string;
    Dir: 'rtl' | 'ltr';
};

type RecordItem = Array<Field>;

type Props = {
    records: Array<RecordItem>;
    onShowResults: () => void;
};

const maxRowCount = defaultRecordsLimit - 1;

// Should be the same as scss variables
const rowHeight = 34;
const borderSpacing = 10;
const headerHeight = 24;

export const MoreInfoTable = ({records, onShowResults}: Props) => {
    const columns = records[0].map((field: Field) => {
        return {
            title: field.ColumnTitle,
            dataIndex: field.ColumnName,
            key: field.ColumnName,
            align: isRTL() ? 'right' : 'left'
        };
    });

    const data = records.map((record, idx) => {
        return record.reduce(
            (acc, field) => {
                return {
                    ...acc,
                    [field.ColumnName]: (
                        <span className={cx(styles.cellValue, {[styles.ltr]: field.Dir === 'ltr'})}>
                            <Value {...field} template={Templates.list} />
                        </span>
                    )
                };
            },
            {key: `${idx}`}
        );
    });

    const dataToRender = data.slice(0, maxRowCount);
    const recordsCount = dataToRender.length;

    const calcTableHeight = useCallback(
        () =>
            recordsCount * (rowHeight + borderSpacing) +
            (headerHeight + borderSpacing) +
            borderSpacing,
        [recordsCount]
    );

    const splitData = texts.results_info.split(' ');
    const tableResultsText = splitData.slice(0, -1).join(' ').replace('X', recordsCount.toString());
    const linkText = splitData[splitData.length - 1] || '';

    return (
        <>
            <Scrollbar
                componentClasses={styles.scroll}
                autoHide={false}
                autoHeight
                autoHeightMin={calcTableHeight()}
                rtl={isRTL()}
            >
                <Table
                    data={dataToRender}
                    columns={columns}
                    componentClasses={styles.component}
                    isResponsive={false}
                />
            </Scrollbar>

            {data.length > maxRowCount ? (
                <div className={styles.resultsInfo}>
                    <Text skin="paragraph-2" tag="div">
                        {tableResultsText}{' '}
                        <Link textSize="large" skin="primary" onClick={onShowResults}>
                            {linkText}
                        </Link>
                    </Text>
                </div>
            ) : null}
        </>
    );
};
